import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Register from './components/Register/register';
import Login from './components/Login/login';
import Instructions from './components/Instructions/instructions';
import Questions from './components/Question/question';
import Admin from './components/Admin/admin';
import ThankYou from './Thankyou/thankyou';
import Malpractice from './Malpractice/malpractice';
import PrivateRoute from './utils/privateroute';

const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || window.innerWidth <= 768;
};

const MobileBlock = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#0d1b2a',
    color: 'white',
    textAlign: 'center',
    padding: '30px',
  }}>
    <div style={{ fontSize: '80px', marginBottom: '20px' }}>📵</div>
    <h1 style={{ color: '#ffa500', fontSize: '26px', marginBottom: '16px' }}>Mobile Device Not Allowed</h1>
    <p style={{ fontSize: '16px', lineHeight: '1.8', maxWidth: '320px', color: '#ccc' }}>
      This exam is not accessible on mobile phones or tablets.<br /><br />
      Please use a <strong style={{ color: 'white' }}>desktop or laptop computer</strong> to access the exam portal.
    </p>
    <div style={{ marginTop: '30px', padding: '12px 24px', backgroundColor: '#ffa500', borderRadius: '8px', fontWeight: 'bold', color: '#000' }}>
      EvaluTech Exam Portal
    </div>
  </div>
);

const App = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileDevice());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) return <MobileBlock />;

  return (
    <Router>
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="/instructions" element={<PrivateRoute element={<Instructions />} />} />
        <Route path="/questions" element={<PrivateRoute element={<Questions />} />} />
        <Route path="/admin" element={<PrivateRoute element={<Admin />} requiredRole={1} />} />
        <Route path="/thankyou" element={<PrivateRoute element={<ThankYou />} />} />
        <Route path="/malpractice" element={<Malpractice />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
